import { makeAutoObservable } from 'mobx';

import { UserType } from '../constants';
import { FileDto, From } from '../dto';

export interface IServerMessageModel {
  id: number;
  groupId: number;
  from: From;
  content: string;
  files: FileDto[];
  at: string; // ISO date 양식
  modified: boolean;
}

export class ServerMessageModel {
  private _id: number;
  private _groupId: number;
  private _from?: From;
  private _content: string;
  private _files: FileDto[];
  private _createdAt: string;
  private _modified: boolean;
  constructor(data: IServerMessageModel) {
    this._id = data.id;
    this._groupId = data.groupId;
    this._from = data.from;
    this._content = data.content;
    this._files = data.files;
    this._createdAt = data.at;
    this._modified = data.modified;
    makeAutoObservable(this);
  }
  get id() {
    return this._id || -1;
  }
  get groupId() {
    return this._groupId;
  }
  get from() {
    return (
      this._from || {
        id: -1,
        name: '',
        type: UserType.CLIENT,
        thumbnail: '',
      }
    );
  }
  get content() {
    return this._content || '';
  }
  get files() {
    return this._files || [];
  }
  set files(files) {
    this._files = files;
  }
  get createdAt() {
    return this._createdAt || '';
  }
  get modified() {
    return this._modified || false;
  }
}
